import { v4 as uuid } from 'uuid';

const environment = (process.env.REACT_APP_ENV || 'development') as string;

const isWindows = navigator.platform.indexOf('Win') > -1;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const configs: Record<string, any> = {
  common: {
    isWindows,
    environment,
    run: uuid(), // Unique ID for the duration of this app run
    endpoints: {},
    keys: {},
    test_user: null,
  },
  development: {
    environment,
    endpoints: {
      api: 'http://localhost:4000/api',
    },
    url: 'http://localhost:3001',
    keys: {},
    test_user: localStorage.getItem('QA_TEST_USER_OVERRIDE'),
  },
  staging: {
    environment,
    endpoints: {
      api: 'https://stage.betterleap-api.com/api',
    },
    url: 'https://stage-admin.betterleap.com',
    keys: {},
    test_user: localStorage.getItem('QA_TEST_USER_OVERRIDE'),
  },
  qa: {
    environment,
    endpoints: {
      api: 'https://qa.betterleap-api.com/api',
    },
    url: 'https://qa-admin.betterleap.com',
    calendly: 'https://calendly.com/youssef43/10min',
    keys: {},
    test_user: localStorage.getItem('QA_TEST_USER_OVERRIDE'),
  },
  production: {
    endpoints: {
      api: 'https://prod.betterleap-api.com/api',
    },
    url: 'https://admin.betterleap.com',
    keys: {},
    test_user: null,
  },
  test: {
    endpoints: {
      api: '',
    },
  },
  test_cypress: {
    endpoints: {
      api: 'https://test-cypress.betterleap-api.com/api',
    },
    test_user: localStorage.getItem('QA_TEST_USER_OVERRIDE'),
  },
};

const config = {
  ...configs.common,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ...configs[environment],
};

export default config;
